// extracted by mini-css-extract-plugin
export default {"conatiner":"NotFound_conatiner__VEfQs","code":"NotFound_code__DuEYU","text":"NotFound_text__0q9lj"};